import React from "react";
import { Navigate, Route } from "react-router-dom";

export const LEADERSHIP_PATH = "/leadership";

/**
 * The four per-role dashboard pages that became the shared Leadership dashboard. Bookmarks to them keep
 * working: each lands on /leadership (which then applies its own login and role guard).
 */
export const LEGACY_LEADERSHIP_PATHS = Object.freeze(["/investment", "/director", "/managing-director", "/chairman"]);

/** One <Route> per old path, to be placed inside <Routes>. Called as a function (a fragment would not be matched). */
export const legacyLeadershipRedirects = () =>
  LEGACY_LEADERSHIP_PATHS.map((path) => (
    <Route key={path} path={path} element={<Navigate to={LEADERSHIP_PATH} replace />} />
  ));
